import useApi from "./useApi";
import * as Sentry from "@sentry/react";

const useWhiteLabeling = () => {
    const { getJson, getBlob } = useApi();

    /**
     * Fetches the white labeling data from the API
     * @param {string} language
     * @param {number} cid
     * @param {number} jobid
     * @returns {Promise<null|*>}
     */
    const fetchWhiteLabelingData = async (language, cid, jobid) => {
        if (language === null || cid === null) {
            return null;
        }
        const queryParams = `?language=${language}&cid=${cid}&jobid=${jobid}`;
        try {
            const data = await getJson(`/online/whitelabel/getdata${queryParams}`);
            return data?.data ?? null;
        } catch (error) {
            Sentry.captureException(error);
            return null;
        }
    };
    
    /**
     * Fetches the image data from the API
     * @param {number|string|null|undefined} assetId
     * @returns {Promise<null|string>}
     */
    const fetchWhiteLabelingImageData = async (assetId) => {
        if (assetId === undefined || assetId === null || parseInt(assetId) === 0) {
            return null;
        }
        try {
            const queryParams = `?asset_id=${assetId}`;
            const data = await getBlob(`/online/whitelabel/getimagedata${queryParams}`, 'image/*');
            if (data === null) {
                return null;
            }
            return URL.createObjectURL(data);
        } catch (error) {
            Sentry.captureException(error);
            return null;
        }
    };
    
    return { fetchWhiteLabelingData, fetchWhiteLabelingImageData };
};

export default useWhiteLabeling;
